import axiosInstance from "./AxiosInstance";

// Invite Member
export const inviteMember = (email) => {
  return axiosInstance.post("api/invite-member", { email });
};


// ✅ Get auto-preference (advice)
export const getAutoPreference = async (body) => {
  try {
    const response = await axiosInstance.post("api/auto-preference",  body );
    return response.data;
  } catch (error) {
    console.error("Error fetching auto-preference:", error);
    throw error;
  }
};
export const getInvitedEmails = async (params) => {
  try {
    const response = await axiosInstance.get("api/address-book", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching invited emails:", error);
    throw error;
  }
};

export const updateLanguage = async (lang) => {
  try {
    const language = lang === "en" ? "English" : "Nederlands";
    const response = await axiosInstance.post("api/update/language", {
      Language: language,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating language:", error);
    throw error;
  }
};
